import { render } from "./index.vue?vue&type=template&id=697fe0da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=697fe0da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697fe0da"],['__file',"src/vab/components/VabSearch/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "697fe0da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('697fe0da', __exports__)) {
    api.reload('697fe0da', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=697fe0da&scoped=true", () => {
    api.rerender('697fe0da', render)
  })

}


export default __exports__